/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — the countdown runs entirely in your browser and nothing is sent to a server.`)
};

const es_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — la cuenta atrás funciona por completo en tu navegador y nada se envía a un servidor.`)
};

const de_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — der Countdown läuft vollständig in deinem Browser, und es wird nichts an einen Server gesendet.`)
};

const nl_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — de aftelling draait volledig in je browser en er wordt niets naar een server gestuurd.`)
};

const fr_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — le compte à rebours fonctionne entièrement dans votre navigateur et rien n'est envoyé à un serveur.`)
};

const it_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — il conto alla rovescia funziona interamente nel tuo browser e niente viene inviato a un server.`)
};

const pt_br2_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — a contagem regressiva roda inteiramente no seu navegador e nada é enviado a um servidor.`)
};

const pt_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — a contagem decrescente corre inteiramente no seu navegador e nada é enviado para um servidor.`)
};

const ja_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ — カウントダウンはブラウザ内で完全に処理され、サーバーには何も送信されません。`)
};

const zh_cd_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会——倒计时完全在你的浏览器中运行，不会向服务器发送任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_a4", locale)
	if (locale === "en") return en_cd_faq_a4(inputs)
	if (locale === "es") return es_cd_faq_a4(inputs)
	if (locale === "de") return de_cd_faq_a4(inputs)
	if (locale === "nl") return nl_cd_faq_a4(inputs)
	if (locale === "fr") return fr_cd_faq_a4(inputs)
	if (locale === "it") return it_cd_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_a4(inputs)
	if (locale === "pt") return pt_cd_faq_a4(inputs)
	if (locale === "ja") return ja_cd_faq_a4(inputs)
	return zh_cd_faq_a4(inputs)
};